import { Component } from '@angular/core';
import {PaneBackButtonComponent} from "../pane-back-button/pane-back-button.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as faIcons from '@fortawesome/free-solid-svg-icons';

import * as AuthSelectors from '../../state/auth/auth.selector';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../auth/primitives/user";
import {ImageCropperComponent} from "ngx-smart-cropper";
import {FilesService} from "../../services/files/files.service";
import {UsersService} from "../../services/users.service";
import {FormsModule} from "@angular/forms";
import {ProfileImageComponent} from "../profile-image/profile-image.component";

@Component({
  selector: 'edit-profile',
  standalone: true,
  imports: [
    PaneBackButtonComponent,
    FontAwesomeModule,
    ImageCropperComponent,
    FormsModule,
    ProfileImageComponent
  ],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss'
})
export class EditProfileComponent {
  protected readonly faIcons = faIcons;
  user: User = null

  displayName: string;
  tagLine: string;

  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private fileService: FilesService,
      private userService: UsersService
  ) {
    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      this.user = user
      this.displayName = user?.display_name
      this.tagLine = user?.tag_line
    })
  }

  croppedImage = '';
  imageSource: string | null = null;

  async onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const reader = new FileReader();
    const blob = await new Promise((resolve, reject) => {
      reader.onload = (e: any) => {
        resolve(e.target.result)
      }
      reader.onerror = (e: any) => reject(e)
      reader.readAsDataURL(file)
    });
    this.fileService.holdBlob(blob as string)
    await this.router.navigate([{outlets: {'right-pane': "profile-edit-image"}}])
  }

  async updateUser() {
    await this.userService.updateUser({
      displayName: this.displayName,
      tagLine: this.tagLine,
      profileImageId: this.user.profile_image_file_id
    })
  }

  async cancel() {
    this.displayName = null;
    this.tagLine = null;
    await this.router.navigate([{outlets: {'right-pane': 'profile'}}])
  }
  async save() {
    await this.updateUser()
    await this.router.navigate([{outlets: {'right-pane': 'profile'}}])
  }
}
